// Value-presence predicate extracted verbatim from the `hasAValue` method of
// components/defaultLayout/EntityDialog&Forms/EntityMaskForm.vue. Already fully
// pure; pulled into its own module so it is unit-tested and survives the
// Nuxt 2 -> Nuxt 3 migration. True when `value` is a present scalar, a non-empty
// array, or a non-empty object; false for undefined / null / '' / [] / {}.

import type { TEntityMaskDataValueTypes } from '~/types/models'

export function hasAValue(value: TEntityMaskDataValueTypes): boolean {
  return (
    value !== undefined &&
    value !== null &&
    value !== '' &&
    ((!Array.isArray(value) && typeof value !== 'object') ||
      (Array.isArray(value) && value.length > 0) ||
      (typeof value === 'object' && Object.entries(value).length > 0))
  )
}
